import { QuickActionsNav } from '@/components/quick-actions-nav.tsx';
import MyProfileAvatar from '@/components/my-profile-avatar.tsx';
import { NotificationRulesTable } from '@/features/notification-rules/components/notification-rules-table/notification-rules-table.tsx';
import { notificationRulesTableColumns } from '@/features/notification-rules/components/notification-rules-table/notification-rules-table-columns.tsx';
import { useGetUserNotificationRulesQuery } from '@/features/notification-rules/hooks/queries/use-get-user-notification-rules.ts';

const NotificationRulesPage = () => {
  const { data: notificationRules, isLoading } = useGetUserNotificationRulesQuery();

  return (
    <div className="w-full gap-2 px-4 pt-3 pb-8 sm:px-6">
      <div className="flex flex-col gap-6">
        <div className="flex h-[45px] items-center justify-between">
          <h1 className="text-xl font-bold sm:text-2xl">Notification Rules</h1>

          <div className="flex gap-2">
            <QuickActionsNav />
            <MyProfileAvatar />
          </div>
        </div>
        <div>
          <NotificationRulesTable
            data={notificationRules || []}
            columns={notificationRulesTableColumns}
            isLoading={isLoading}
          />
        </div>
      </div>
    </div>
  );
};

export default NotificationRulesPage;
